const ConnectorType = Object.freeze({
  CustomerApplication: 'CUS',
  ShipperApplication: 'SHP',
  FulfilmentApplication: 'FFA'
})

export default ConnectorType
